import { render, staticRenderFns } from "./MyStudentsList.vue?vue&type=template&id=135f46ea&scoped=true&"
import script from "./MyStudentsList.vue?vue&type=script&lang=js&"
export * from "./MyStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./MyStudentsList.vue?vue&type=style&index=0&id=135f46ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f46ea",
  null
  
)

export default component.exports